import React from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';

/**
 * Weeks and Litter Size component
 */
const WeeksLitterSlider = (props) => (
  <div className="nppe2-fc-weeks-litter-slider nppe2-fc-slider">
    <div className="row">
      <div className="col-xs-12 nppe2-fc-slider__text" disabled={props.greyedWeeks}>
        {props.data.data.weeks}
      </div>
      <div className="col-xs-12 text-right nppe2-fc-slider__text--red" disabled={props.greyedWeeks}>
        {props.selectedWeeks}

      </div>
    </div>
    <Slider
      name="nppe2-fc-weeks-slider"
      value={props.selectedWeeks}
      min={1}
      max={props.maxWeeks}
      step={1}
      disabled={props.greyedWeeks}
      onChange={(value) => props.onSelectWeeks(value)}
    />
    <a href="#" className="nppe2-fc-weeks-litter-info-button" aria-label={props.data.data.aria}>
      {props.openModalWithContent}
      <div className="nppe2-fc-info-button"
        onClick={ (e) => {
          props.openModalWithContent("WeeksLitterInfo");
          e.preventDefault();
        }}>
      </div>
    </a>

  </div>
);

export default WeeksLitterSlider;
